import { Department } from './department.model';

export class DepartmentMapper {
  public static map(departmentData: any): Department {
    if (!departmentData) {
      return null;
    }

    return new Department(
        departmentData.id,
        departmentData.name
      );
  }
}



// WEBPACK FOOTER //
// /dist/src/app/user/work-record/department.mapper.ts